export const urls = {
  isValidUrl: (value?: string) => {
    if (!value) {
      return false;
    }

    try {
      return Boolean(new URL(value));
    } catch (er) {
      return false;
    }
  },
};
